import _this from '../main.js';

const env = process.env.NODE_ENV

export const ip = env == 'development' ? API_IP.dev : API_IP.prod 


// const token = COOKIE.get('token')
// export const headers = {
//     'token': token
// }


axios.defaults.baseURL = ip;
// axios.defaults.headers = headers



const response = function(obj) {

    obj.interceptors.request.use(config => {
        return config;
    }, err => {
        Message.error({ message: '请求超时!' });
        return Promise.resolve(err);
    })


    obj.interceptors.response.use(data => {
        return data;
    }, err => {
        if (err.response == undefined && err.message == 'Network Error') {
            _this.$message.error('网络异常,无法连接到网络');
        } else {
            switch (err.response.status) {
                case 404:
                    if (err.response.data.error == "Not Found") {
                        _this.$message.error('未找到内容');
                    }
                    break;
                default:
                    if (err.response.data.code == "InternalError") {
                        _this.$message.error('服务器内部错误');
                    } else if (err.response.data.message == "TIMEOUT") {
                        _this.$message.error('请求超时');
                    } else {
                        _this.$message.error('服务器错误');
                    }
                    break;
            }
        }

        return Promise.resolve(err);
    })
}


response(axios)

Vue.prototype.axios = axios;



// WEBPACK FOOTER //
// ./src/config/axiosConfig.js